import React from 'react'
import { getGreeting } from '../utils/GetGreetings'

function GreetingCard({ fullname }) {
    return (
        <div>
            <div className='space-y-0'>
                <h1 className="text-xl font-bold">{getGreeting()},</h1>
                <p className="text-gray-500">{fullname}</p>
                <p></p>
            </div>
        </div>
    )
}

export default GreetingCard